it("should parse a Coffeescript style function expression in require.ensure", function(done) {
	require.ensure([], (function(_this) {
		return function(require) {
			require("./file").should.be.eql("ok");
			done();
		};
	}(this)));
});

it("should parse a bound function expression in require.ensure", function(done) {
	require.ensure([], function(require) {
		require("./file").should.be.eql("ok");
		done();
	}.bind(this));
});


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/chunks/index.js
 ** module id = 0
 ** module chunks = 0
 **/